var React = require('react');

function CrownIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2 19H22V21H2V19ZM2 5L7 8.5L12 2L17 8.5L22 5V17H2V5ZM4 8.841V15H20V8.841L16.58 11.235L12 5.28L7.42 11.235L4 8.84V8.841Z","fill":"url(#paint0_linear_1186_7429)","key":0}),React.createElement("defs",{"key":1},React.createElement("linearGradient",{"id":"paint0_linear_1186_7429","x1":"7.12494","y1":"4.37512","x2":"16.1775","y2":"19.4016","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"offset":"0.3125","stopColor":"#5D44B7","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#FFA6C1","key":1})]))]);
}

CrownIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CrownIcon;

CrownIcon.default = CrownIcon;
